import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import s from './MetamaskModal.module.scss'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { CModal } from 'components/UI/Modal/CModal'

interface MetamaskIsDisabledModalProps {
  onHide: () => void
}

const MetamaskIsDisabledModal: FC<MetamaskIsDisabledModalProps> = (props) => {
  const { onHide } = props
  const navigate = useNavigate()

  return (
    <CModal variant="secondary" onHide={onHide} className={s.modal}>
      <CModal.Info className={s.infoWrapper}>
        <CModal.Title>Metamask extension is unavailable</CModal.Title>
        <p className={s.subheader}> Please download it, then click 'OK' and try to connect again.</p>
        <CustomButton
          className={s.okButton}
          size="180"
          variant="secondary"
          onClick={() => {
            navigate(0)
            onHide()
          }}
        >
          OK
        </CustomButton>
      </CModal.Info>
    </CModal>
  )
}

export default MetamaskIsDisabledModal
